import { LANG_EN, LANG_FR, getTargetLanguage, getLanguageStrings } from '../util/language'

const initialState = {
    language: LANG_EN,
    strings: getLanguageStrings(LANG_EN)
}

export default function language(state = initialState, action) {
    switch(action.type) {
        case "TOGGLE_LANGUAGE":
            let newLang = getTargetLanguage(state.language);
            let newStrings = getLanguageStrings(newLang);
            document.title = newStrings.PAGE_TITLE;
            return {
                ...state,
                language: newLang,
                strings: newStrings,
            }
        case "SET_LANGUAGE":
            if (action.language === undefined || action.language === null) {
                action.language = LANG_EN;
            }
            if (action.language !== LANG_EN && action.language !== LANG_FR) {
                action.language = LANG_EN;
            }
            let strings2 = getLanguageStrings(action.language);
            document.title = strings2.PAGE_TITLE;
            return {
                ...state,
                language: action.language,
                strings: strings2,
            }
        default:
            return state;
    }
}
